"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Modal = require("@insided/shared/uikit/Modal");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _DropdownBox = _interopRequireDefault(require("@insided/deprecated-control/EmailCampaigns/DropdownBox"));

var _datePicker = _interopRequireDefault(require("@insided/deprecated-preact-components/date-picker"));

var _flatpickr = _interopRequireDefault(require("flatpickr"));

var _TimepickerV = _interopRequireDefault(require("@insided/deprecated-preact-components/timepicker/TimepickerV2"));

var _DropdownList = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownList"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ScheduleModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ScheduleModal, _Component);

  var _super = _createSuper(ScheduleModal);

  function ScheduleModal() {
    var _this;

    (0, _classCallCheck2.default)(this, ScheduleModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      date: new Date(_this.props.schedule.date),
      time: new Date("".concat(_this.props.schedule.date, " ").concat(_this.props.schedule.time))
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDateChange", function (dates) {
      _this.setState({
        date: dates[0]
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCloseTimepicker", function (dates) {
      if (dates) {
        _this.setState({
          time: dates[0]
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSchedule", function () {
      var _this$state = _this.state,
          date = _this$state.date,
          time = _this$state.time;

      _this.props.onSchedule(date, time);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCancel", function () {
      _this.setState({
        date: new Date(_this.props.schedule.date),
        time: new Date("".concat(_this.props.schedule.date, " ").concat(_this.props.schedule.time))
      });

      _this.props.onClose();
    });
    return _this;
  }

  (0, _createClass2.default)(ScheduleModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          schedule = _this$props.schedule,
          isOpen = _this$props.isOpen,
          timezoneDropdownItems = _this$props.timezoneDropdownItems,
          isScheduled = _this$props.isScheduled,
          sendActionPending = _this$props.sendActionPending;
      var _this$state2 = this.state,
          date = _this$state2.date,
          time = _this$state2.time;
      return (0, _preact.h)(_Modal.Modal, {
        isOpen: isOpen,
        size: "large",
        className: "email-campaigns-schedule-modal"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: isScheduled ? 'Reschedule this email campaign?' : 'Ready to schedule this email campaign?',
        onClose: this.onCancel
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("p", {
        className: "modal-description"
      }, "Send out the email to all recipients, including new ones who matches the criteria at the scheduled time"), (0, _preact.h)("div", {
        className: "schedule"
      }, (0, _preact.h)(_DropdownBox.default, {
        disabled: false,
        title: (0, _preact.h)("span", {
          className: "dropdown-title"
        }, (0, _preact.h)("span", {
          className: "dropdown-label"
        }, "Date"), (0, _preact.h)("span", {
          className: "dropdown-value"
        }, _flatpickr.default.formatDate(date, 'M d Y'))),
        dataElementName: "schedule data dropdown"
      }, (0, _preact.h)(_datePicker.default, {
        disableInput: true,
        value: date,
        onChange: this.onDateChange
      })), (0, _preact.h)(_DropdownBox.default, {
        disabled: false,
        title: (0, _preact.h)("span", {
          className: "dropdown-title"
        }, (0, _preact.h)("span", {
          className: "dropdown-label"
        }, "Time"), (0, _preact.h)("span", {
          className: "dropdown-value"
        }, _flatpickr.default.formatDate(time, 'h:i K'))),
        dataElementName: "schedule time dropdown"
      }, (0, _preact.h)(_TimepickerV.default, {
        disableInput: true,
        value: time,
        onClose: this.onCloseTimepicker
      })), (0, _preact.h)(_DropdownBox.default, {
        disabled: false,
        title: (0, _preact.h)("span", {
          className: "dropdown-title"
        }, (0, _preact.h)("span", {
          className: "dropdown-label"
        }, "Timezone"), (0, _preact.h)("span", {
          className: "dropdown-value"
        }, schedule.timeZone.title)),
        dataElementName: "schedule timezone dropdown"
      }, (0, _preact.h)(_DropdownList.default, {
        items: timezoneDropdownItems,
        align: "adjust",
        type: "timezone",
        hasSearch: true,
        isOpen: true
      })))), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
        title: isScheduled ? 'Yes, reschedule email' : 'Yes, schedule email',
        onClick: this.onSchedule,
        disabled: sendActionPending,
        size: "medium",
        variant: "brand",
        className: "qa-schedule-email-campaign",
        "data-track-type": "click",
        "data-element-name": "Scheduling email confirmation button"
      }), (0, _preact.h)(_Button.default, {
        title: "Cancel",
        onClick: this.onCancel,
        disabled: sendActionPending,
        size: "medium",
        "data-track-type": "click",
        "data-element-name": "Cancel button"
      })));
    }
  }]);
  return ScheduleModal;
}(_preact.Component);

exports.default = ScheduleModal;